import styled from 'styled-components'
import { colors } from 'styles/colors'
import { mobile } from 'styles/responsive'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;

    > * + * {
        margin-top: 50px;
    }

    .button {
        font-size: 16px;
        font-weight: 800;
        padding: 16px 30px;
    }
`

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 50px;

    > * + * {
        margin-top: 15px;
    }

    ${mobile(`
        padding: 15px 15px 0 15px;
    `)}
`

export const Title = styled.h1`
    font-size: 40px;
    font-weight: 700;
    line-height: 36px;
    color: ${colors.darkGreen};

    ${mobile(`
        font-size: 32px;
    `)}
`

export const Desc = styled.div`
    font-size: 21px;
    font-weight: 500;
    line-height: 26px;
    color: ${colors.black};

    ${mobile(`
        font-size: 19px;
    `)}
`

export const Link = styled.a`
    text-decoration: none;
    color: ${colors.defaultGreen};
`

export const LinkNoMobile = styled.a`
    text-decoration: none;
    color: ${colors.defaultGreen};

    ${mobile(`
        display: none;
    `)}
`
